import api from './api';

class DiscountService {
  // Get all discounts with optional filters
  async getAllDiscounts(filters = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filters.type) params.append('type', filters.type);
      if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
      if (filters.promoCode) params.append('promoCode', filters.promoCode);
      if (filters.status) params.append('status', filters.status);
      if (filters.productId) params.append('productId', filters.productId);
      if (filters.page) params.append('page', filters.page);
      if (filters.limit) params.append('limit', filters.limit);

      const response = await api.get(`/discounts/admin/all?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching discounts:', error);
      throw error;
    }
  }

  // Get discount by ID
  async getDiscountById(id) {
    try {
      const response = await api.get(`/discounts/admin/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching discount:', error);
      throw error;
    }
  }

  // Create new discount
  async createDiscount(discountData) {
    try {
      const response = await api.post('/discounts/admin', discountData);
      return response.data;
    } catch (error) {
      console.error('Error creating discount:', error);
      throw error;
    }
  }

  // Update discount
  async updateDiscount(id, discountData) {
    try {
      const response = await api.put(`/discounts/admin/${id}`, discountData);
      return response.data;
    } catch (error) {
      console.error('Error updating discount:', error);
      throw error;
    }
  }

  // Delete discount
  async deleteDiscount(id) {
    try {
      const response = await api.delete(`/discounts/admin/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting discount:', error);
      throw error;
    }
  }

  // Get discount statistics
  async getDiscountStats() {
    try {
      const response = await api.get('/discounts/admin/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching discount stats:', error);
      throw error;
    }
  }

  // Validate promo code
  async validatePromoCode(promoCode, orderAmount = 0) {
    try {
      const response = await api.post('/discounts/validate-coupon', {
        code: promoCode,
        cartItems: [],
        totalAmount: orderAmount
      });
      return response.data;
    } catch (error) {
      console.error('Error validating promo code:', error);
      throw error;
    }
  }

  // Get active coupon codes
  async getActiveCouponCodes() {
    try {
      const response = await api.get('/discounts/active');
      return response.data;
    } catch (error) {
      console.error('Error fetching active coupon codes:', error);
      throw error;
    }
  }
}

const discountService = new DiscountService();
export default discountService;
